module.exports = __webpack_public_path__ + "static/media/lcme.30fe50f0.PNG";